import React, { Box, Typography } from '@mui/material';
import { FC, useMemo } from 'react';
import { DateFormat } from 'app/enums';
import { DateTimeFormat } from 'shared/components/Format/DateTimeFormat';
import { CHAMPION_LABEL } from '../../constants';
import { DoubleEliminationGroup } from '../../enums';
import { useStyles } from './BracketHeader.styles';

interface DoubleEliminationBracketHeaderProps {
  title: string | JSX.Element;
  bestOf: number;
  startedAt: string;
  roundIndex: number;
  group?: DoubleEliminationGroup;
}

export const BracketHeader: FC<DoubleEliminationBracketHeaderProps> = ({
  title,
  bestOf,
  startedAt,
  group = DoubleEliminationGroup.Upper,
  roundIndex,
}) => {
  const { classes } = useStyles();
  const isStartedAtDatePresent = useMemo(() => {
    if (group !== DoubleEliminationGroup.Lower) {
      return Boolean(startedAt);
    }

    return !(roundIndex % 2) && roundIndex ? false : Boolean(startedAt);
  }, [group, roundIndex, startedAt]);

  if (title === CHAMPION_LABEL) {
    return (
      <Box className={classes.root}>
        <Typography variant="subtitle2" textAlign="center" color="text.primary">
          {title}
        </Typography>
      </Box>
    );
  }

  return (
    <Box className={classes.root}>
      <Typography variant="subtitle2" textAlign="center" color="text.primary">
        {title}
      </Typography>
      <Typography variant="subtitle2" textAlign="center" color="primary.light">
        {`Best of ${bestOf}`}
      </Typography>
      {isStartedAtDatePresent && (
        <Typography variant="subtitle2" textAlign="center" color="primary.light">
          <DateTimeFormat date={startedAt} format={DateFormat.YyyyMmDdHhMm} />
        </Typography>
      )}
    </Box>
  );
};
